import React from "react";
import NnNote from "./NnNote";
import Note from "./Note";
import Song from "./Song";

// Song.js -- example usage:
// var twink = new Song('Twinkle');   // create a song
// twink.rawNotes = ["C", "C", "G", "G", "A", "A", "G", "F", "F", "E", "E", "D", "D", "C`"];
// twink.lyrics = ["/4", "/4", "/4", "/4", "/4", "/4", "/2", "/4", "/4", "/4", "/4", "/4", "/4", "/2"];
// twink.adjustTimingAndLyrics(); // creates the formatted version of notes and lyrics with padding to align visually
// document.getElementById("output1").innerHTML = ('<pre>' + song2.formattedLyrics + '</pre>'); // write result into the page
// document.getElementById("output2").innerHTML = ('<pre>' + song2.formattedNotes + '</pre>');
//
class NnSong extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      song: props.song,
      title: "",
      position: 0,
      notes: []
    };
  }

  render() {
    return (
      <div className="SongInfo">
        <h2 className="SongTitle">{this.state.title}</h2>
        <div className="SongLyrics">
          <ul id="song-display">
            {this.state.notes
              .slice(this.state.position)
              .map((n, i) => <NnNote note={n} key={i} />)}
          </ul>
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.song && nextProps.song !== this.state.song) {
      this.setState({
        song: nextProps.song,
        title: nextProps.song.title,
        notes: nextProps.song.notes,
        position: nextProps.song.position
      });
    }
  }
  /*
  currentNote() {
    return this.notes[this.currentPosition];
  }

  advance() {
    let i = this.currentPosition++;
    // TODO end of song... what next?
    if (i === this.notes.length - 1) {
      i = this.currentPosition = 0;
    }
    return this.notes[i];
  }

  // calculate the milliseconds per beat based on the song tempo
  // duration in msec/beat = 60 sec/min * 1000 msec/sec / tempo beats/min
  getBeatDuration() {
    return 60 * 1000 / this.tempo; // milliseconds per beat--i.e. per quarter note in 4/4 time
  }

  // Get the note value per beat by assuming an integer after "/" in the time signature e.g. "5/8"
  getTimeSignatureDenominator() {
    return parseInt(this.timeSignature.split("/")[1], 10);
  }

  // play the notes of this song starting at 'position', respecting note pitch and duration
  play(position) {
    if (position < this.notes.length) {
      let note = this.notes[position];
      let duration = note.getDurationInMsec(
        this.getBeatDuration(),
        this.getTimeSignatureDenominator()
      );
      console.log(`playing ${note.raw} for ${duration} msec/`);
      note.play();
      setTimeout(() => this.play(position + 1), duration);
    }
  }
  */
}
export default NnSong;



// WEBPACK FOOTER //
// ./src/NnSong.js